import { useSelector, useStore } from "react-redux";

// reducers
import { clearActiveImage, selectImage } from "hyc-store/reducers/image";

const ImageModal = () => {
    const store = useStore();
    const data = useSelector(selectImage);

    const handleClick = () => {
        store.dispatch(clearActiveImage());
    }

    if (!data) {
        return null;
    }

    return (
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-content">
                <p class="image">
                    <img src={data.img} alt={data.alt} />
                </p>
            </div>

            <button class="modal-close is-large"
                aria-label="close" onClick={handleClick} />
        </div>
    );
};

export { ImageModal };
